import { sortBy } from 'lodash';
import type { ICandidateColumn } from './CandidateColumns';

/**
 * Ordina le colonne dei candidati in base all'ordine definito nel widget
 */
export function sortCandidateColumns(
  columns: ICandidateColumn[],
  columnOrder?: string[],
): ICandidateColumn[] {
  if (!columnOrder) return columns;

  return sortBy(columns, column => columnOrder.indexOf(column.name));
}
